import { z } from "zod";
import {
  DESCRIPTION,
  ENTITY_ID,
  ENTITY_TYPE,
  FILE,
} from "./consts";

export const schema = z.object({
  [ENTITY_ID]: z.string().optional(),
  [ENTITY_TYPE]: z.string().optional(),
  [FILE]: z.any(),
  [DESCRIPTION]: z.string().optional(),
});

export type formValues = z.infer<typeof schema>;
